"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.323A7.589 7.589 0 0 0 4.437 8.29l-.244 2.979a6.59 6.59 0 0 1-.96 2.92l-.853 1.383c-.36.581-.495 1.265-.27 1.881.236.643.81 1.058 1.538 1.169 1.444.22 3.962.425 8.352.425 4.391 0 6.909-.205 8.352-.425.73-.111 1.302-.526 1.538-1.169.226-.616.09-1.3-.27-1.881l-.852-1.382a6.59 6.59 0 0 1-.96-2.921l-.245-2.979A7.588 7.588 0 0 0 12 1.323ZM8.135 20.347c1.102.04 2.38.063 3.866.063 1.484 0 2.762-.023 3.864-.063a4.317 4.317 0 0 1-7.73 0Zm4.32-16.865a.795.795 0 0 0 0 1.59c1.66 0 3.143 1.4 3.297 3.358a.795.795 0 0 0 1.586-.125c-.21-2.67-2.281-4.823-4.883-4.823Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgNotification);
var _default = exports["default"] = Memo;